const currencyFormatters = new Map<string, Intl.NumberFormat>();

export function formatCurrency(
  amount: number | string,
  currency = "GBP",
): string {
  const num = typeof amount === "string" ? parseFloat(amount) : amount;
  if (isNaN(num)) return "—";

  const key = currency.toUpperCase();
  if (!currencyFormatters.has(key)) {
    currencyFormatters.set(
      key,
      new Intl.NumberFormat("en-GB", { style: "currency", currency: key }),
    );
  }
  return currencyFormatters.get(key)!.format(num);
}

const dateFormatter = new Intl.DateTimeFormat("en-GB", {
  day: "numeric",
  month: "short",
  year: "numeric",
});

const dateTimeFormatter = new Intl.DateTimeFormat("en-GB", {
  day: "numeric",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});

export function formatDate(d: Date | string | number | null | undefined): string {
  if (!d) return "—";
  const date = d instanceof Date ? d : new Date(typeof d === "number" && d < 1e12 ? d * 1000 : d);
  if (isNaN(date.getTime())) return "—";
  return dateFormatter.format(date);
}

export function formatDateTime(d: Date | string | number | null | undefined): string {
  if (!d) return "—";
  const date = d instanceof Date ? d : new Date(typeof d === "number" && d < 1e12 ? d * 1000 : d);
  if (isNaN(date.getTime())) return "—";
  return dateTimeFormatter.format(date);
}

const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });

export function formatRelativeTime(
  d: Date | string | number | null | undefined,
): string {
  if (!d) return "—";
  const date = d instanceof Date ? d : new Date(typeof d === "number" && d < 1e12 ? d * 1000 : d);
  if (isNaN(date.getTime())) return "—";

  const diffMs = date.getTime() - Date.now();
  const absDiffMs = Math.abs(diffMs);

  if (absDiffMs < 60_000) return "just now";
  if (absDiffMs < 3_600_000)
    return rtf.format(Math.round(diffMs / 60_000), "minute");
  if (absDiffMs < 86_400_000)
    return rtf.format(Math.round(diffMs / 3_600_000), "hour");
  if (absDiffMs < 2_592_000_000)
    return rtf.format(Math.round(diffMs / 86_400_000), "day");
  return formatDate(date);
}
